import { gql } from 'apollo-boost';

export const REQUEST_DATA_EXPORT = gql`
    mutation RequestDataExport($data: DataExportOptionsInput) {
        requestDataExport(data: $data) {
            id
            status
            scope
            options {
                exportType
                includeNotes
                includeFiles
                includeImages
                includeVideos
                includeAudio
                includeLinks
            }
            resultUrl
            expiresAt
            error
            declinedAt
            declinedReason
            cancelledAt
            createdAt
            completedAt
        }
    }
`;
